import { EuiSpacer } from '@elastic/eui';
import ConformityCards from 'components/Outdoor_Cameras/IN-9820_QFHD/Safety_Warnings/ConformityCards';
import NavButtons from 'components/Outdoor_Cameras/IN-9820_QFHD/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  ConformityCards,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};